import Header from '../src/Components/Header';

function App() {
  return (
    <div className="App">
        <Header/>
    </div>
  );
}

export default App;
